import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { getDefaultLanguage } from "../../toStdLanguages";

const LanguageWrapper = ({ children }: { children: any }) => {
  const { i18n } = useTranslation();

  useEffect(() => {
    const storedLanguage = getDefaultLanguage();
    if (storedLanguage && storedLanguage !== i18n.language) {
      i18n.changeLanguage(storedLanguage);
      document.documentElement.lang = storedLanguage;
    }
  }, [i18n]);

  return children;
};

export default LanguageWrapper;
